import { mxConfig } from '../config';

if (mxConfig.linkedinId?.length) {
  const _linkedin_partner_id: string = mxConfig.linkedinId;
  //@ts-ignore
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  //@ts-ignore
  window._linkedin_data_partner_ids.push(_linkedin_partner_id);
}
